/* src/app/shared/components/info-alert/info-alert.component.scss */
.alert-container {
  display: flex;
  align-items: center;
  background-color: #FFF;
  padding: 10px;
  margin-bottom: 10px;
}
.alert-icon {
  color: #F03C64;
  margin-right: 10px;
  font-size: 20px;
}
.alert-message {
  font: 400 14px FranceTV Brown;
}
/*# sourceMappingURL=info-alert.component.css.map */
